import { useCustomerOrder } from "@backpackjs/storefront";
import ProductCard from "../globals/layout/ProductCard";
import React from 'react';

export default function OrderRecommendation({orderId, title, showBWPBadge, aboveTheFold, index}) {
  const { order } = useCustomerOrder({ id: orderId });

  if (!order) { return; }

  const matchingLineItem = order?.lineItems.find((item) => item.title === title);

  if (!matchingLineItem?.variant?.product?.handle || matchingLineItem?.variant?.availableForSale === false) { return; }

  return (
    <ProductCard
      handle={matchingLineItem.variant.product.handle}
      showReviews={false}
      quickViewButton="bottom"
      key={`order-recommendation-${index}`}
      showBWPBadge={showBWPBadge}
      belowFold={!aboveTheFold}
      isSection
    />
  )
}